export default __webpack_public_path__ + "static/media/flag-somaliland.214781bd.svg";